import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a19758b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod-title mt-2" }
const _hoisted_2 = { class: "d-flex flex-column flex-lg-row flex-md-row align-items-start" }
const _hoisted_3 = { class: "m-0 fw-semibold" }
const _hoisted_4 = { class: "d-flex mt-lg-0 mt-md-0 mt-1 ms-lg-1 ms-md-1 ms-0" }
const _hoisted_5 = { class: "version-header-badge rounded px-2 py-1" }
const _hoisted_6 = { class: "ms-2 author-header-badge rounded px-2 py-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, "Мод " + _toDisplayString(_ctx.title) + " для " + _toDisplayString(_ctx.getPrettyGame(_ctx.game)), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.version), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.author), 1)
      ])
    ])
  ]))
}